import * as React from "react";
import {Card} from "react-bootstrap";
import {useStockInformationQuery} from "../../../hooks/useStockInformationQuery";
import {ProductStatusModel} from "../../../models/view/productStatusModel";

export const ProductStatusContainer = () => {
    const {model, error} = useStockInformationQuery();
    if (!model || error) return <></>;
    return (<ProductStatus model={model.productStatusModel}/>)
};

function ProductStatus({model: {status, isNewProduct}}: { model: ProductStatusModel }) {
    const productStatusMessage = ProductStatusMessage()
    const newProductMessage = NewProductMessage();

    return (
        <>
            {productStatusMessage && <li><span className="text-danger fw-bold">{productStatusMessage}</span></li>}
            {isNewProduct && <li><span className="text-danger fw-bold">{newProductMessage}</span></li>}
        </>
    )

    function ProductStatusMessage() {
        switch (status) {
            case "OnSale":
                return "This product is currently on sale!"
            case "Closeout0":
            case "Closeout1":
            case "Closeout2":
            case "Closeout3":
            case "Terminated1":
            case "Terminated2":
            case "Clearout2":
                return "This product is being closed out at record low prices!"
            case "Overstock":
                return "This product is on overstock sale. Enjoy limited time savings!"
        }
    }

    function NewProductMessage() {
        return "Brand New Arrival!"
    }
}
